export default __webpack_public_path__ + "static/media/upgrade-3-img.0d77a6fa.png";